// extracted by mini-css-extract-plugin
export var outlinedCard = "_redotech-redo-customer-portal-app-lib-portal-four-returns-confirmation-outlined-card";
export var typeAnimationText = "_redotech-redo-customer-portal-app-lib-portal-four-returns-confirmation-type-animation-text";